/* Afridi Imports — storefront forms → CRM (Returns & Claims, Contact messages).
   Spec: crm.imports.pk docs/superpowers/specs/2026-10-17-returns-claims-and-contact-forms-design.md
   The claim form posts to the CRM and shows the thank-you in place (claim number, video upload, WhatsApp).
   If the CRM cannot be reached, the form falls back to its normal HTML submit so nothing is lost. */
(function () {
  'use strict';
  var MAX_FILES = 3;
  var MAX_BYTES = 80 * 1024 * 1024;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html !== undefined) e.innerHTML = html; return e; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function icon(name) { return '<svg class="aip-ico" viewBox="0 0 24 24" aria-hidden="true"><use href="#aip-i-' + name + '"/></svg>'; }

  function postJson(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), keepalive: true, mode: 'cors', credentials: 'omit' })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, status: r.status, data: j }; }); });
  }

  /* ---------------- Return / replacement claim form ---------------- */
  var form = $('form.aip-claim[data-crm]');
  if (form) {
    var base = form.getAttribute('data-crm').replace(/\/+$/, '');
    var card = form.closest('.aip-card') || form.parentElement;
    var submitBtn = $('button[type=submit]', form);
    var fallbackAction = form.getAttribute('action');

    form.addEventListener('submit', function (e) {
      if (form.dataset.fallback === '1') return; // second submit = native fallback
      e.preventDefault();
      if (!form.checkValidity()) { form.reportValidity(); return; }
      var fd = new FormData(form);
      var payload = {
        name: String(fd.get('name') || '').trim(),
        phone: String(fd.get('phone') || '').trim(),
        orderNumber: String(fd.get('order_id') || '').trim(),
        email: String(fd.get('email') || '').trim() || undefined,
        purpose: (String(fd.get('purpose') || 'Replacement').toLowerCase() === 'return') ? 'return' : 'replacement',
        message: String(fd.get('message') || '').trim() || undefined,
        website: String(fd.get('website') || ''),
        page: location.href.slice(0, 500),
        consent: true
      };
      var old = submitBtn.innerHTML;
      submitBtn.disabled = true; submitBtn.textContent = 'Sending…';
      postJson(base + '/claims', payload).then(function (res) {
        if (res.ok && res.data && res.data.claimNumber) { renderThankYou(res.data, payload); return; }
        if (res.status === 429) { showError('Too many requests from this connection. Please wait a few minutes and try again, or message us on WhatsApp.'); return; }
        if (res.status === 400 && res.data && res.data.message) { showError(Array.isArray(res.data.message) ? res.data.message[0] : res.data.message); return; }
        fallback();
      }).catch(fallback);

      function showError(msg) {
        submitBtn.disabled = false; submitBtn.innerHTML = old;
        var box = $('.aip-form-error', form) || form.insertBefore(el('div', 'aip-note is-red aip-form-error'), form.firstChild);
        box.textContent = msg;
        box.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
      function fallback() {
        // CRM unreachable: let the browser post to the email fallback so the request still reaches the team.
        if (fallbackAction) { form.dataset.fallback = '1'; form.submit(); return; }
        showError('We could not send your request right now. Please try again or message us on WhatsApp.');
      }
    });

    function renderThankYou(data, payload) {
      var number = data.claimNumber;
      var wa = data.whatsapp || {};
      var dup = !!data.duplicate;
      var box = el('div', 'aip-success aip-thanks');
      box.innerHTML =
        '<div class="aip-badge">' + icon('check') + '</div>' +
        '<h2 class="aip-thanks-h">' + (dup ? 'We already have your request' : 'Request received') + '</h2>' +
        '<p class="aip-thanks-no">Claim number <strong>' + esc(number) + '</strong></p>' +
        '<p>' + (dup ? 'An open claim already exists for this order and phone number. We will continue on that one.' : 'Thank you ' + esc(payload.name.split(' ')[0]) + '. Our Complaints &amp; after-sales team will WhatsApp you on ' + esc(payload.phone) + ' between 9am and 6pm.') + '</p>' +
        '<ol class="aip-steps aip-thanks-steps">' + (data.nextSteps || []).map(function (s) { return '<li><b>' + esc(s) + '</b></li>'; }).join('') + '</ol>' +
        '<div class="aip-upload" data-token="' + esc(data.token || '') + '">' +
          '<div class="aip-sub">Upload your unboxing video now (optional)</div>' +
          '<p class="aip-upload-p">Speeds up your claim. Up to ' + MAX_FILES + ' files, 80 MB each (mp4, webm, photos).</p>' +
          '<label class="aip-btn aip-btn-line aip-upload-btn">' + icon('video') + ' Choose video or photo<input type="file" accept="video/mp4,video/webm,image/jpeg,image/png" hidden></label>' +
          '<ul class="aip-upload-list"></ul>' +
        '</div>' +
        '<div class="aip-hero-cta aip-thanks-cta">' +
          (wa.url ? '<a class="aip-btn aip-btn-wa" href="' + esc(wa.url) + '" target="_blank" rel="noopener">' + icon('wa') + 'WhatsApp Care ' + esc(wa.number || '') + '</a>' : '') +
          '<a class="aip-btn aip-btn-navy" href="/">' + icon('cart') + 'Continue shopping</a>' +
        '</div>' +
        '<p class="aip-thanks-foot">Save your claim number. You can check its status any time in the "Track your claim" box on this page.</p>';
      card.innerHTML = '';
      card.appendChild(box);
      card.scrollIntoView({ block: 'start', behavior: 'smooth' });
      wireUpload(box, number);
      var barBtn = $('.aip-bar .aip-btn-navy'); if (barBtn) { barBtn.setAttribute('href', '#track'); barBtn.innerHTML = icon('search') + 'Track claim'; }
      if (window.dataLayer) window.dataLayer.push({ event: 'claim_submitted', claim_type: payload.purpose, duplicate: dup });
    }

    function wireUpload(box, number) {
      var wrap = $('.aip-upload', box), input = $('input[type=file]', wrap), list = $('.aip-upload-list', wrap), btn = $('.aip-upload-btn', wrap);
      var token = wrap.getAttribute('data-token'), count = 0;
      if (!token) { wrap.style.display = 'none'; return; }
      input.addEventListener('change', function () {
        var file = input.files && input.files[0]; input.value = '';
        if (!file) return;
        if (file.size > MAX_BYTES) { addRow(file.name, 'Too large (max 80 MB). Please send it on WhatsApp.', 'err'); return; }
        if (count >= MAX_FILES) { addRow(file.name, 'Limit reached. Send more on WhatsApp.', 'err'); return; }
        var row = addRow(file.name, 'Uploading… 0%', 'busy');
        var xhr = new XMLHttpRequest();
        xhr.open('POST', base + '/claims/' + encodeURIComponent(number) + '/media?token=' + encodeURIComponent(token));
        xhr.upload.onprogress = function (ev) { if (ev.lengthComputable) row.querySelector('.aip-upload-st').textContent = 'Uploading… ' + Math.round(ev.loaded / ev.total * 100) + '%'; };
        xhr.onload = function () {
          if (xhr.status >= 200 && xhr.status < 300) { count++; setRow(row, 'Uploaded ✓', 'ok'); if (count >= MAX_FILES) btn.style.display = 'none'; }
          else { var msg = 'Upload failed. Please send it on WhatsApp.'; try { var j = JSON.parse(xhr.responseText); if (j && j.message) msg = Array.isArray(j.message) ? j.message[0] : j.message; } catch (e) {} setRow(row, msg, 'err'); }
        };
        xhr.onerror = function () { setRow(row, 'Upload failed. Please send it on WhatsApp.', 'err'); };
        var fd = new FormData(); fd.append('file', file, file.name);
        xhr.send(fd);
      });
      function addRow(name, status, cls) { var li = el('li', 'aip-upload-row is-' + cls, '<span class="aip-upload-nm">' + esc(name) + '</span><span class="aip-upload-st">' + esc(status) + '</span>'); list.appendChild(li); return li; }
      function setRow(li, status, cls) { li.className = 'aip-upload-row is-' + cls; li.querySelector('.aip-upload-st').textContent = status; }
    }
  }

  /* ---------------- Track your claim ---------------- */
  var track = $('form.aip-track[data-crm]');
  if (track) {
    var tbase = track.getAttribute('data-crm').replace(/\/+$/, '');
    var out = $('.aip-track-out');
    track.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!track.checkValidity()) { track.reportValidity(); return; }
      var fd = new FormData(track);
      var btn = $('button[type=submit]', track); var old = btn.innerHTML; btn.disabled = true; btn.textContent = 'Checking…';
      out.innerHTML = '';
      postJson(tbase + '/claims/lookup', { claimNumber: String(fd.get('claimNumber') || '').trim().toUpperCase(), phone: String(fd.get('phone') || '').trim() }).then(function (res) {
        btn.disabled = false; btn.innerHTML = old;
        if (!res.ok) { out.innerHTML = '<div class="aip-note is-warn">' + esc(res.status === 404 ? 'No claim found for that claim number and phone. Check both and try again.' : (res.data && res.data.message) || 'Could not check right now. Please try again.') + '</div>'; return; }
        var d = res.data;
        out.innerHTML =
          '<div class="aip-track-card">' +
            '<div class="aip-track-head"><span class="aip-track-no">' + esc(d.claimNumber) + '</span><span class="aip-track-pill' + (d.terminal ? ' is-bad' : '') + '">' + esc(d.statusLabel) + '</span></div>' +
            '<ol class="aip-track-steps">' + (d.steps || []).map(function (s) { return '<li class="' + (s.done ? 'is-done' : s.current ? 'is-current' : '') + '"><span></span>' + esc(s.label) + '</li>'; }).join('') + '</ol>' +
            (d.rejectionReason ? '<div class="aip-note is-red"><strong>Reason:</strong> ' + esc(d.rejectionReason) + '</div>' : '') +
            '<p class="aip-track-next">' + esc(d.nextAction || '') + '</p>' +
            (d.order ? '<p class="aip-track-meta">Order ' + esc(d.order.name) + (d.pickupDate ? ' · pickup ' + esc(d.pickupDate) : '') + ' · ' + (d.mediaCount ? d.mediaCount + ' file(s) received' : 'no videos received yet') + '</p>' : '') +
          '</div>';
      }).catch(function () { btn.disabled = false; btn.innerHTML = old; out.innerHTML = '<div class="aip-note is-warn">Could not check right now. Please try again.</div>'; });
    });
  }

  /* ---------------- Contact form copy → CRM ---------------- */
  var contact = $('.t4s-contact-form form, form[action*="/contact"]');
  var orgEl = document.querySelector('[data-crm-org]');
  var orgId = ((form && form.getAttribute('data-crm')) || (track && track.getAttribute('data-crm')) || '').match(/public\/([0-9a-f-]{36})/i);
  var crmOrigin = (form || track) ? (form || track).getAttribute('data-crm').split('/api/')[0] : 'https://crm.imports.pk';
  if (contact && contact.querySelector('[name="contact[body]"]')) {
    var org = (orgEl ? orgEl.getAttribute('data-crm-org') : '').trim();
    if (!org && orgId) org = orgId[1];
    if (org) {
      contact.addEventListener('submit', function () {
        try {
          var g = function (n) { var f = contact.querySelector('[name="contact[' + n + ']"]'); return f ? String(f.value || '').trim() : ''; };
          var body = { name: g('name') || 'Website visitor', email: g('email') || undefined, phone: g('phone') || undefined, subject: g('subject') || undefined, message: g('body'), website: '', page: location.href.slice(0, 500) };
          if (!body.message) return;
          // keepalive: the copy survives the page navigation that Shopify's own submit triggers.
          fetch(crmOrigin + '/api/forms/public/' + org + '/contact', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), keepalive: true, mode: 'cors', credentials: 'omit' }).catch(function () {});
        } catch (e) { /* never block the native submit */ }
      });
    }
  }
})();
